// extracted by mini-css-extract-plugin
export default {"crypto":"icons_crypto__YQ7qw","inst":"icons_inst__GMhiZ","cash":"icons_cash__kjJ6N","card":"icons_card__kC588","bank":"icons_bank__UMPC7"};